import { render, staticRenderFns } from "./OldBrowserPageWarn.vue?vue&type=template&id=f39d2a50&"
import script from "./OldBrowserPageWarn.vue?vue&type=script&lang=js&"
export * from "./OldBrowserPageWarn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CA5\\PhpstormProjects\\te-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('f39d2a50', component.options)
    } else {
      api.reload('f39d2a50', component.options)
    }
    module.hot.accept("./OldBrowserPageWarn.vue?vue&type=template&id=f39d2a50&", function () {
      api.rerender('f39d2a50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Pages/OldBrowserPageWarn.vue"
export default component.exports